/*
 * @Descripttion: '顶部菜单'
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 08:50:24
 * @LastEditTime: 2021-04-28 09:30:00
 */

export const menuList = [
  {
    id: 1,
    label: '项目管理',
    url: '/legalDaily/projectManagement',
  },
  {
    id: 2,
    label: '报名管理',
    url: '/legalDaily/reportManagement',
  },
  {
    id: 3,
    label: '酒店管理',
    url: '/legalDaily/hotelManagement',
  },
]